import { ReactNode, useState } from 'react'

import { CheckCircleFilled, ExportOutlined } from '@ant-design/icons'
import { Button, Flex, Tooltip } from 'antd'
import { createStyles } from 'antd-style'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'
import { stringifyUrl } from '@eastcoal/common/utils/querystring'

import { AuctionListTitleRenderProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  idIcon: {
    display: 'inline-block',
    width: '18px',
    height: '18px',
    lineHeight: '18px',
    fontSize: token.fontSizeSM,
    color: token.colorWhite,
    backgroundColor: token.colorTextTertiary,
    borderRadius: token.borderRadiusXS,
    cursor: 'pointer'
  },
  linkIcon: {
    color: token.colorTextTertiary
  }
}))

export const AuctionListTitleRender = ({
  createPath,
  record
}: AuctionListTitleRenderProps) => {
  const { styles, theme } = useStyles()

  const defaultTitle = `复制ID: ${record.id}`
  const [title, setTitle] = useState<ReactNode>(defaultTitle)

  const handleCopyID = () => {
    navigator.clipboard.writeText(`${record.id}`)
    setTitle(
      <Flex gap={4}>
        <CheckCircleFilled style={{ color: theme.green }} />
        <span>已复制到剪贴板</span>
      </Flex>
    )
  }

  const handleResetTitle = () => {
    setTimeout(() => {
      setTitle(defaultTitle)
    }, 200)
  }

  return (
    <>
      <Tooltip title={title}>
        <Button
          icon={<span className={styles.idIcon}>ID</span>}
          type='text'
          onClick={handleCopyID}
          onMouseLeave={handleResetTitle}
        />
      </Tooltip>
      <span>{record.title}</span>
      <Tooltip title='复制场次'>
        <NavigateButton
          newtab
          icon={<ExportOutlined className={styles.linkIcon} />}
          size='small'
          type='text'
          to={stringifyUrl({
            url: createPath,
            query: {
              id: record.id
            }
          })}
        />
      </Tooltip>
    </>
  )
}
